import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import { hasPermission } from '../utils/permission';

const RoleGuard = ({ allowedRoles = [], requiredPermission, children }) => {
  const { user } = useAuth();

  let isUnauthorized = false;
  if (user) {
    if (user.role === 'admin') {
      isUnauthorized = false;
    } else if (requiredPermission) {
      isUnauthorized = !hasPermission(user, requiredPermission);
    } else {
      // Fallback: check allowedRoles or if customRole matches legacy roles mapping
      const hasSystemRoleMatch = allowedRoles.includes(user.role);
      const hasCustomRoleMatch = !!user.roleDetails && allowedRoles.some(role => {
        const roleLower = role.toLowerCase();
        const userRoleLower = (user.role || '').toLowerCase();
        if (roleLower === 'cc_head' && (userRoleLower.includes('manager') || userRoleLower.includes('head') || userRoleLower.includes('ops') || userRoleLower.includes('supervisor'))) {
          return true;
        }
        if (roleLower === 'accountant' && (userRoleLower.includes('accountant') || userRoleLower.includes('finance'))) {
          return true;
        }
        if (roleLower === 'customer_care' && (userRoleLower.includes('care') || userRoleLower.includes('cc'))) {
          return true;
        }
        return false;
      });
      isUnauthorized = !hasSystemRoleMatch && !hasCustomRoleMatch;
    }
  }

  useEffect(() => {
    if (isUnauthorized) {
      toast.error('You do not have permission to access this area.');
    }
  }, [isUnauthorized]);

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (isUnauthorized) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default RoleGuard;
